import React from "react";
import {StyledBoxRow,} from "@/shared/StyledComponents";
import {Button} from "@mui/material";
import {BaseApp} from "@/shared/BaseApp";
import {SendEmailDialog} from "@/libwyze-shared/components/SendEmailDialog";
import {MailTemplateId} from "@/libwyze-common/api/types";
import {BaseMessageCampaignFragment} from "../BaseMessageCampaignFragment";
import {BaseEmailCampaignCustomizeOptions} from "@/vantage-shared/types";

export type Email = {
  subject: string,
  body: string,
}

export abstract class BaseEmailCampaignFragment<OPTIONS extends BaseEmailCampaignCustomizeOptions> extends BaseMessageCampaignFragment<Email, OPTIONS> {

  protected renderTestButtons(): React.ReactElement {
    return <StyledBoxRow>
      <Button
        onClick={() => {
          const id = BaseApp.CONTEXT.showDialog(
            null,
            () => <SendEmailDialog
              templateId={this.campaignConfig.email.templateId as MailTemplateId}
              replaceStrings={this.campaignConfig.email.replaceStrings.asArray()}
              onSent={() => BaseApp.CONTEXT.hideDialog(id)}/>
          );
        }}
        variant={"outlined"}>
        Send test Email
      </Button>
    </StyledBoxRow>;
  }
}